/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendEmail.defs.js'
export { main as default } from './sendEmail.defs.js'
